import {
  Home, Building2, Briefcase, Hammer, Sparkles, ShowerHead,
  LayoutGrid, Grid3x3, Layers, PaintBucket, Zap, Package,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEstimate } from "@/lib/track";

const SERVICES = [
  { icon: Home, title: "Apartment Renovation Dubai", text: "Complete apartment remodeling — from single rooms to full turnkey renovation." },
  { icon: Building2, title: "Home Renovation Dubai", text: "End-to-end home renovation — layout changes, finishes, MEP and interior upgrade." },
  { icon: Briefcase, title: "Villa Renovation Dubai", text: "Full villa renovation with layout modification, premium finishing and approvals." },
  { icon: Hammer, title: "Complete Property Renovation", text: "Demolition to handover — every trade managed under one project." },
  { icon: Sparkles, title: "Kitchen Renovation Dubai", text: "Cabinetry, countertops, appliances, lighting and plumbing." },
  { icon: ShowerHead, title: "Bathroom Renovation Dubai", text: "Waterproofing, tiling, vanity, shower glass and premium fixtures." },
  { icon: LayoutGrid, title: "Interior Fit-Out", text: "Turnkey interior fit-out from demolition through final handover." },
  { icon: Grid3x3, title: "Flooring", text: "Premium tiles, wooden flooring, herringbone, marble and large-format solutions." },
  { icon: Layers, title: "Gypsum Ceiling & Partitions", text: "Designer ceilings, cove lighting, dropped ceilings and partitions." },
  { icon: PaintBucket, title: "Painting", text: "Interior and exterior painting with premium finishes." },
  { icon: Zap, title: "Electrical & Plumbing", text: "Full MEP works — rewiring, lighting, sanitary and system upgrades." },
  { icon: Package, title: "Custom Joinery", text: "Wardrobes, TV units, kitchen cabinets, wall cladding and storage." },
];

export default function ServicesPillars() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            Services
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-4 leading-[1.1]">
            Complete Apartment &amp; Home Renovation Services in Dubai
          </h2>
          <p className="text-base lg:text-lg text-neutral-600">
            Everything you need for your renovation — under one professional team.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200 mb-10">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-${i}`}
              className="bg-white p-6 lg:p-7 hover:bg-[#F9F8F6] transition-colors group"
            >
              <div className="w-10 h-10 bg-[#C5A059]/10 flex items-center justify-center mb-4 group-hover:bg-[#C5A059] transition-colors">
                <s.icon className="w-5 h-5 text-[#C5A059] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-heading text-lg font-medium text-neutral-900 mb-2 leading-snug">
                {s.title}
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">{s.text}</p>
            </article>
          ))}
        </div>

        <div className="text-center">
          <a href="#lead-form" data-testid="services-cta" onClick={() => trackEstimate("services_section")}>
            <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-8 py-7 font-semibold tracking-wide">
              GET MY ROUGH RENOVATION ESTIMATE
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
